import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair, QualityId } from '../../models/index';

class MultiQualitySelectorController implements angular.IComponentController {

    model: number[];
    items: KeyValuePair<number, string>[];
    readonly disabled: boolean;

    static $inject = [];

    $onInit() {
        this.items = [
            { key: QualityId.Missing, value: QualityId[QualityId.Missing] },
            { key: QualityId.Bad, value: QualityId[QualityId.Bad] },
            { key: QualityId.Flat, value: QualityId[QualityId.Flat] },
            { key: QualityId.OutOfRange, value: QualityId[QualityId.OutOfRange] },
            { key: QualityId.Scatter, value: QualityId[QualityId.Scatter] },
            { key: QualityId.Suspicious, value: QualityId[QualityId.Suspicious] },
            { key: QualityId.Invalid, value: QualityId[QualityId.Invalid] },
            { key: QualityId.Corrected, value: QualityId[QualityId.Corrected] }
        ];
    }
}

export const wtMultiQualitySelector: ComponentDefinition = {
    componentId: 'wtMultiQualitySelector',
    controller: MultiQualitySelectorController,
    template: require('./multiQualitySelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        disabled: '<?',
        model: '='
    }
};